module.exports = __webpack_public_path__ + "img/icon-eye-hide.5571ef72.svg";